import { withData as LOADER } from '@ott/utility-loader';

const wrapToKey = (key, result) => {
  if (!key) {
    return result;
  }
  if (typeof key === 'object') {
    return key;
  }

  return { [key]: result };
};

// eslint-disable-next-line no-underscore-dangle
const _mapToKey = (action, result) => result;
// eslint-disable-next-line no-underscore-dangle
const _getRequestId = (action, state) => state.requestId;

const defaultOpts = {
  mapToKey: _mapToKey,
};

module.exports = (types, opts = defaultOpts) => {
  const [START, SUCCESS, FAIL, RESET] =
    typeof types === 'string'
      ? [types, `${types}_SUCCESS`, `${types}_FAIL`, `${types}_RESET`]
      : types;

  const {
    mapToKey = _mapToKey,
    getRequestId = _getRequestId,
    ignored = (action, state) => {
      const stateId = getRequestId(action, state);
      const actionId = action.requestId;

      return actionId != null && stateId != null && actionId !== stateId;
    },
    initialState = { ...LOADER.initial() },
  } = opts;

  const result = (action, res, state) => {
    const defaultData = action.defaultData || res.data;
    const data = res.data != null ? res.data : defaultData;
    // eslint-disable-next-line no-param-reassign
    res = { ...res, data, requestId: action.requestId || state.requestId };

    return wrapToKey(mapToKey(action, res), res, action);
  };

  return (state = initialState, action) => {
    switch (action.type) {
      case START:
        return {
          ...state,
          ...result(action, LOADER.begin(), state),
        };

      case SUCCESS:
        if (ignored(action, state)) {
          return state;
        }

        return {
          ...state,
          ...result(action, LOADER.success(action.result), state),
        };
      case FAIL:
        if (ignored(action, state)) {
          return state;
        }

        return {
          ...state,
          ...result(action, LOADER.error(action.error), state),
        };

      case RESET:
        if (ignored(action, state)) {
          return state;
        }

        return {
          ...state,
          ...result(action, LOADER.initial(), state),
          requestId: null,
        };
      default:
        return state;
    }
  };
};
